<template>
      <aside :class="`${is_expanded ? 'is-expanded' : ''}`">
        <!-- Tiene de inmediato el ancho final de la barra: mientras el aside anima
        su ancho solo lo va recortando, sin reacomodar el texto -->
        <div class="contenido-barra">
          <v-container class="logoDI" @click.stop="onLogoClick">
            <LogoDINavBar :is_expanded="is_expanded"></LogoDINavBar>
          </v-container>

          <div class="menu-toggle-wrap mt-2">
            <button class="menu-toggle" @click="ToggleMenu">
              <span class="material-icons">keyboard_double_arrow_right</span>
            </button>
          </div>

          <div class="menu">
            <v-list-item
              v-for="seccion in menu"
              :key="seccion.to"
              :to="seccion.to"
              :class="{ 'v-list-item--active primary white--text': seccion.to === activa }"
            >
              <v-list-item-icon
                style="padding-left:20px !important; margin-right:20px !important "
              >
                <v-icon>{{ seccion.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ seccion.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
      </aside>
</template>

<script>

import LogoDINavBar from '@/components/icons/logoDINavBar.vue';
import { MENU_ADMIN, MENU_ALUMNO, seccionActiva } from './menu';

export default {
  components: {
    LogoDINavBar,
  },
  props: ["is_expanded"],
  data: () => ({
    toggle: true,
    toggleMobile: false,
  }),

  computed: {

    tablet () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return false
          case 'sm': return true
          case 'md': return true
          case 'lg': return false
          case 'xl': return false
        }

        return false
      },

    desktop () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return false
          case 'sm': return false
          case 'md': return false
          case 'lg': return true
          case 'xl': return true
        }

        return false
      },

    current_user() {
      return this.$store.state.authentication.user;
    },

    is_admin() {
      return this.$store.state.authentication.user.is_staff;
    },

    menu() {
      return this.is_admin ? MENU_ADMIN : MENU_ALUMNO;
    },

    activa() {
      return seccionActiva(this.menu, this.$route.path);
    },
  },
  methods: {
    /*change_drawer() {
      this.$store.dispatch("drawer");
    },*/
    /*sizecard(drawer) {
      if (drawer) {
        return 9;
      } else {
        return 12;
      }
    },*/
    onLogoClick(){
      const inicio = this.menu[0].to;
      if (this.$route.path !== inicio) {
        this.$router.push(inicio);
      }
    },
    ToggleMenu () {
      let expanded_var = !this.is_expanded
      // se envía el valor actualizado al componente padre, que se lo va a entregar correctamente a navigation_bar
      this.$emit("update-is_expanded", expanded_var);
    }
  },
};
</script>

<style lang="scss" scoped>
.card-actions {
  position: absolute;
  bottom: 0;
}

v-list-item--active:hover::before,
.v-list-item--active::before {
  opacity: 0 !important;
}

.wrapper {
  overflow: hidden;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

.logoDI {
  cursor: pointer;
} 

aside {
	--sidebar-width: 17rem;
	display: flex;
	flex-direction: column;
	background-color: var(--dark);
	color: var(--light);
	width: calc(5rem + 32px);
	overflow: hidden;
	min-height: 100vh;
	padding: 1rem;
	transition: 0.2s ease-in-out;
	.contenido-barra {
		flex-shrink: 0;
		width: 5rem;
	}
	.flex {
		flex: 1 1 0%;
	}
	.menu-toggle-wrap {
		display: flex;
		justify-content: flex-end;
		position: relative;
		top: 0;
    right:1rem;
		transition: 0.2s ease-in-out;
		.menu-toggle {
			transition: 0.2s ease-in-out;
			.material-icons {
				font-size: 2rem;
				color: var(--light);
				transition: 0.2s ease-out;
			}
			
			&:hover {
				.material-icons {
					color: var(--primary);
					transform: translateX(0.5rem);
				}
			}
		}
	}
	h3, .button .text {
		opacity: 0;
		transition: opacity 0.3s ease-in-out;
	}
	h3 {
		color: var(--grey);
		font-size: 0.875rem;
		margin-bottom: 0.5rem;
		text-transform: uppercase;
	}
	.menu {
		.button {
			display: flex;
			align-items: center;
			text-decoration: none;
			transition: 0.2s ease-in-out;
			padding: 0.5rem 1rem;
			.material-icons {
				font-size: 2rem;
				color: var(--light);
				transition: 0.2s ease-in-out;
			}
			.text {
				color: var(--light);
				transition: 0.2s ease-in-out;
			}
			&:hover {
				background-color: var(--dark-alt);
				.material-icons, .text {
					color: var(--primary);
				}
			}
			&.router-link-exact-active {
				background-color: var(--dark-alt);
				border-right: 5px solid var(--primary);
				.material-icons, .text {
					color: var(--primary);
				}
			}
		}
	}
	.footer {
		opacity: 0;
		transition: opacity 0.3s ease-in-out;
		p {
			font-size: 0.875rem;
			color: var(--grey);
		}
	}
	&.is-expanded {
		width: var(--sidebar-width);
		.contenido-barra {
			width: calc(var(--sidebar-width) - 2rem);
		}
		.menu-toggle-wrap {
      right:-1%;
			
			.menu-toggle {
				transform: rotate(-180deg);
			}
		}
		h3, .button .text {
			opacity: 1;
		}
		.button {
			.material-icons {
				margin-right: 1rem;
			}
		}
		.footer {
			opacity: 0;
		}
	}
}
</style>
